import React, { useState, useEffect } from "react";
import { Row, Col, Table, Badge, Button } from "react-bootstrap";
import Marketingsidebar from "../../../components/Marketing_bar";
import Bankimage from "../../../assets/images/Wallet/bank_pic.png";
import { useNavigate } from "react-router-dom";
import url from "../../../config/axios";

const MyPayments = () => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [profitData, setProfitData] = useState([]);
  const [loading, setLoading] = useState(true);

  const memarketerid = localStorage.getItem("MeAsmarketerId");

  const PROFIT_PERCENTAGE = 50;

  useEffect(() => {
    const fetchProfit = async () => {
      try {
        setLoading(true);

        const response = await url.get(
          `marketingagent/getProfitByMarketerId?marketerId=${memarketerid}`
        );

        setProfitData(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching profit data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (memarketerid) {
      fetchProfit();
    }
  }, [memarketerid]);

  // ✅ Total Sales
  const totalSales = profitData.reduce((sum, item) => {
    return sum + (item?.planId?.pricing?.monthly?.amount || 0);
  }, 0);

  // ✅ Total Profit
  const totalProfit = (totalSales * PROFIT_PERCENTAGE) / 100;

  // ✅ 🔥 MANUAL ARRAY (EDIT THIS ANYTIME)
  const transactions = [
    // {
    //   date: "2024-07-26",
    //   shop: "Tech Solutions Inc.",
    //   plan: "Enterprise",
    //   amount: "PKR 500",
    //   status: "Completed",
    //   id: "TXN12345",
    // },
  ];

  return (
    <Row>
      <div className="screenHeight marketing-height-manage p-3">

        {/* Sidebar */}
        <Col
          lg="3"
          className="bg-white shadow-sm marketing-sidebar-height sidebar-border rounded"
        >
          <Marketingsidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        </Col>

        {/* Main */}
        <Col
          lg={8}
          className="p-5 shadow rounded"
          style={{ backgroundColor: "#f8fbff" }}
        >
          <h2 className="mb-5">My Payments</h2>

          {/* Summary */}
          <div className="bg-white rounded-3 shadow-sm p-4 mb-4">
            <p className="mb-1 text-muted">Total Earned</p>
            <h3>
              PKR: {totalProfit ? totalProfit.toLocaleString() : "0"}
            </h3>
          </div>

          {/* Bank */}
          <div className="bg-white rounded-3 shadow-sm p-4 mb-4">
            <h5 className="mb-4">Linked Bank Account</h5>

            <div className="d-flex justify-content-between flex-wrap gap-3">
              <div>
                <p><strong>Account Holder:</strong> User Name</p>
                <p><strong>Bank:</strong> First National Bank</p>
                <p><strong>Account:</strong> ****1234</p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "green" }}>Verified</span>
                </p>

                <Button onClick={() => navigate("/link-account")}>
                  Change Bank
                </Button>
              </div>

              <img
                src={Bankimage}
                alt="bank"
                style={{ maxWidth: "250px" }}
              />
            </div>
          </div>

          {/* Transactions */}
          <div className="bg-white rounded-3 shadow-sm p-4">
            <h5 className="mb-4">Transaction / Commission History</h5>

            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <Table hover>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Shop/User</th>
                    <th>Plan</th>
                    <th>Commission</th>
                    <th>Status</th>
                    <th>Transaction ID</th>
                  </tr>
                </thead>

                <tbody>
                  {transactions.length > 0 ? (
                    transactions.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.shop}</td>
                        <td>{row.plan}</td>
                        <td>{row.amount}</td>
                        <td>
                          <Badge
                            bg={
                              row.status === "Completed"
                                ? "success"
                                : "warning"
                            }
                          >
                            {row.status}
                          </Badge>
                        </td>
                        <td>{row.id}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center p-4 text-muted">
                        No transactions yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>

        </Col>
      </div>
    </Row>
  );
};

export default MyPayments;